import React from 'react';

import { AuthProvider } from './auth';
import { AlertProvider } from './alert';

const AppProvider: React.FC = ({ children }) => {
  return (
    <>
      <AuthProvider>
        <AlertProvider>{children}</AlertProvider>
      </AuthProvider>
    </>
  );
};

export default AppProvider;
